// extracted by mini-css-extract-plugin
module.exports =  {"btn":"a867bdd7c0--btn--kJrwj","phone":"a867bdd7c0--phone--D4r3Z","icon":"a867bdd7c0--icon--uhy7K","active":"a867bdd7c0--active--rwE45"};